import axios from 'axios';

import config from '../configs';
import utils from '../utils';
import services from '../services';

const commonService = {
  getHomePageData: (successCallback, errorCallback) => {
    axios
      .get(config.apiUrl + 'common/homepage', {
        headers: {
          Authorization: utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          '',
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },

  getDropdownData: async (page, successCallback, errorCallback) => {
    axios
      .get(config.apiUrl + 'common/dropdown?page=' + page, {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          '',
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },

  upload: (payload, successCallback, errorCallback) => {
    axios
      .post(config.apiUrl + 'common/upload', payload)
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(exception, payload, '');
        errorCallback(exception);
      });
  },
  getProvinces: async (successCallback, errorCallback) => {
    axios
      .get(config.apiBaseUrl + 'api/v3/address/provinces', {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          '',
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  getCities: async (payload, successCallback, errorCallback) => {
    axios
      .post(config.apiBaseUrl + 'api/v3/address/cities', payload, {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          '',
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  getDistricts: async (payload, successCallback, errorCallback) => {
    axios
      .post(config.apiBaseUrl + 'api/v3/address/districts', payload, {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          '',
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },
  getSubDistricts: async (payload, successCallback, errorCallback) => {
    axios
      .post(config.apiBaseUrl + 'api/v3/address/subdistricts', payload, {
        headers: {
          Authorization: 'Token ' + utils.store.get('token'),
        },
      })
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(
          exception,
          '',
          utils.store.get('token'),
        );
        errorCallback(exception);
      });
  },

  get: (uri, successCallback, errorCallback) => {
    axios
      .get(config.apiUrl + uri)
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(exception, '', '');
        errorCallback(exception);
      });
  },

  post: (uri, payload, successCallback, errorCallback) => {
    axios
      .post(config.apiUrl + uri, payload)
      .then((response) => {
        successCallback(response.data);
      })
      .catch((exception) => {
        services.sentry.handleSentryApiError(exception, payload, '');
        errorCallback(exception);
      });
  },
};

export default commonService;
